<div mat-dialog-title class="flex">
  <h3>{{ title }}</h3>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content>
  <form [formGroup]="form" (submit)="f.form.valid && save()" #f="ngForm" novalidate>
    <div class="row">
      <mat-form-field class="col-md-12">
        <input matInput placeholder="Title" formControlName="moduleTitle" required />
      </mat-form-field>
    </div>

    <div class="mb-2">
      <button type="button" class="mat-raised-button" (click)="close()">Close</button>
      <button type="submit" class="mat-raised-button mat-primary ml-2">Save</button>
    </div>
  </form>
</mat-dialog-content>
